var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      staticClass: "green-operation__electricity",
      attrs: {
        title: _vm.$t("tenancy.greenOperation.assessments.electricityData"),
      },
    },
    [
      _c(
        "div",
        { staticClass: "row", attrs: { slot: "content" }, slot: "content" },
        [
          _c("div", { staticClass: "small-12" }, [
            _c("span", { staticClass: "font-bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "tenancy.greenOperation.assessments.electricityTableTitle"
                    )
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.isTenant && _vm.sortedSubmittedDocs.length === 0
            ? [_vm._v("\n      " + _vm._s(_vm.$t("emptyValue")) + "\n    ")]
            : _vm.sortedSubmittedDocs.length > 0
            ? _c(
                "div",
                { staticClass: "small-12" },
                [
                  _c("HKLTable", {
                    attrs: {
                      dataSource: _vm.sortedSubmittedDocs,
                      columns: _vm.columns,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }